module.exports = __webpack_public_path__ + "static/media/DTUS-26-Conference-LOGO.48a56eff.png";